jQuery(document).ready(function($) {

  $('.woocommerce-variation.single_variation').html('$0.00');

  $(document.body).on('updated_cart_totals', function() {
    initQuantityIncrement();
  });

  initQuantityIncrement();

  $('.variation').each(function (index, element) {
    var packField = $(element).find('#pack');
    if (packField.length > 0) {
      $(packField).closest('.variation').css('width', '100%');
    }
  });

  function initQuantityIncrement() {
    $('.plus-minus-input input').change(function() {
      if($('.update-cart').length && !$(this).hasClass('processing-update')) {
        $('.update-cart').trigger('click');
      }
    });
    // This button will increment the value
    $('[data-quantity="plus"]').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('data-field');
        // Get its current value
        var currentVal = parseInt($('#'+fieldName).val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('#'+fieldName).val(currentVal + 1).trigger('change');
            if($('.update-cart').length) {
              $(this).closest('input').addClass('processing-update');
              $('.update-cart').trigger('click');
            }
        } else {
            // Otherwise put a 0 there
            $('#'+fieldName).val(0).trigger('change');
            if($('.update-cart').length) {
              $('.update-cart').trigger('click');
            }
        }
    });
    // This button will decrement the value till 0
    $('[data-quantity="minus"]').click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('data-field');
        // Get its current value
        var currentVal = parseInt($('#'+fieldName).val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('#'+fieldName).val(currentVal - 1).trigger('change');
            if($('.update-cart').length) {
              $('.update-cart').trigger('click');
            }
        } else {
            // Otherwise put a 0 there
            $('#'+fieldName).val(0).trigger('change');
            if($('.update-cart').length) {
              $('.update-cart').trigger('click');
            }
        }
    });
  }

  $(document).ajaxComplete(function() {
    if ($('body').hasClass('woocommerce-checkout') || $('body').hasClass('woocommerce-cart')) {
      $('html, body').stop();
    }
  });

  $('.shop_table .wcsatt-options').remove();

(function($) {
        /**
        * Change Price Variation to correct position
        */
        $(".woocommerce-variation").insertAfter(".variations");
        $('.variations_form').on('woocommerce_variation_has_changed', function () {
            $(".woocommerce-variation").insertAfter(".variationsp");
        });
    })( jQuery );



});
